<template>
    <div :class="getCSSClass('file-picker-native-container')">
        <div :class="getCSSClass('file-picker-native-preview-container')" v-if="!showFilename">
            <img v-if="imgSource != ''"
                 :src="imgSource"
                 :class="getCSSClass('file-picker-native-preview-image')">
            <span v-if="imgSource == ''"
                  v-html="icon('blankfile')"
                  :class="getCSSClass('file-picker-native-preview-image')"></span>

        </div>
        <div :class="getCSSClass('file-picker-native-input-container')">
            <div style="display: flex; align-items: center; justify-content: center; width: 100%; flex-grow: 1"
                 v-if="showFilename">
                <input type="text" v-bind:value="fileLabel" readonly style="flex-grow: 1">
                <button v-if="fileLabel != ''"
                        v-html="icon('close')"
                        style="margin-left: -1.5rem"
                        v-on:click="$emit('input', '')"></button>
            </div>
            <label style="display: flex">
                <input type="file"
                       v-on:change="handleChange($event)"
                       :ref="'fileinput'"
                       :accept="accept"
                       style="visibility: hidden; width: 0; height: 0; padding: 0; margin: 0; border: 0; opacity: 0; flex-grow:0">
                <button v-html="label"
                        type="button"
                        :class="getCSSClass('file-picker-native-input-button')" v-on:click="$refs['fileinput'].click()"></button>
            </label>

        </div>

    </div>
</template>

<script>
    import {ajaxUploadMixin} from "./mixins/ajaxUploadMixin";

    export default {
        mixins: [ajaxUploadMixin],
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            uploadUrl: {type: String},
            value: {},
            label: {type: String, default: '...'},
            showFilename: {type: Boolean, default: false},
            accept: {type: String, default: 'image/png, image/jpeg'},
            uploadAction: {type: String, default: 'storeProfilePicture'}
        },
        data: function () {
            return {
                imgSource: ''
            }
        },
        mounted() {
            if (this.value) {
                this.imgSource = this.value;
            }
        },
        methods: {
            loadPreview: async function(file) {
                let id = await this.uploadFileAsync(file);
                window.axios.post(this.uploadUrl, {id: id, action: this.uploadAction, type: file.type, name: file.name})
                    .then((response) => {
                        this.$emit('input', response.data);
                    }).catch((error) => {
                        alert(error);
                    });
            },
            handleChange: function(payload) {
                if ((payload) && (payload.target) && (payload.target.files[0])) {

                    this.loadPreview(payload.target.files[0]);
                } else {
                    this.$emit('input', null);
                }
            }
        },
        computed: {
            fileLabel: function() {
                if (this.value) {
                    let fn = this.value.split('/').pop();
                    if (fn) {
                        return fn;
                    }
                }
                return '';
            }
        },
        watch: {
            value: function() {
                this.imgSource = this.value;
            }
        }

    }
</script>
